var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 20,
    viewBox: "0 0 19 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.0431 8.27868L5.21093 1.68516C3.18044 0.449207 0.644217 2.19763 1.07706 4.53496L3.37424 16.9398C3.83546 19.4303 7.13322 20.0258 8.43638 17.8539L10.1799 14.9481C10.3504 14.6638 10.6269 14.4589 10.9486 14.3785L15.2803 13.2956C17.6489 12.7034 18.1287 9.54815 16.0431 8.27868Z",
    stroke: "white",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowIcon);
export default __webpack_public_path__ + "static/media/ArrowIcon.0a5826c45dc398b71b1719fb79c99d7a.svg";
export { ForwardRef as ReactComponent };